import React, { createContext } from "react";
import type { UnitGroup } from "@/types";

export interface UnitItemContextType {
    unitGroup: UnitGroup;
    selectedPromo: number;
    setSelectedPromo: React.Dispatch<React.SetStateAction<number>>;
}

export const UnitItemContext = createContext<UnitItemContextType | null>(null);
